import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonSelect,
  IonSelectOption,
  IonToolbar
} from "@ionic/react";
import "./scores.scss";
import { useEffect, useState } from "react";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "./../../icon/icon.png";
import ScoreTable from "../../components/scores/scoreTable";
import ScoreTable2 from "../../components/scores/scoreTable2";

const Scores: React.FC = () => {
  const [showProgessBar, setShowProgessBar] = useState(true);
  let base_url = process.env.REACT_APP_BASE_URL;
  let coffee_tools = new coffeeTools();
  const urlParams = new URLSearchParams(window.location.search);

  const [general, setGeneral] = useState([]);
  const [ofensive, setOfensive] = useState([]);
  const [defensive, setDefensive] = useState([]);
  const [local, setLocal] = useState([]);
  const [visitor, setVisitor] = useState([]);

  //declared outside to make it global and used it on the page

  const [filterSeason, setFilterSeason] = useState([]);

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    let coffee = new coffeeTools();
  }, []);

  var controller = (() => {
    function getSeasons(callback) {
      fetch(base_url + "/sports/seasons/all", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }

    async function getTable(id_season, endpoint) {
      return fetch(base_url + endpoint, {
        method: "POST",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_season: id_season
        })
      }).then((response) => response.json());
    }

    return {
      getSeasons: (callback) => getSeasons(callback),
      getTable: (id_season, endpoint) => getTable(id_season, endpoint)
    };
  })();

  let view = (() => {
    let dom_obj = {
      scores_table_container: "js__scores_table_container"
    };

    // used in the season filter
    function showSeason(response) {
      let select_season = [];
      if (response.items.length > 0) {
        response.items.forEach(function (item) {
          select_season.push(
            <IonSelectOption
              key={item.id}
              value={item.id}
            >
              {item.name}
            </IonSelectOption>
          );
        });
        setFilterSeason(select_season);
      }
    }

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    return {
      showSeason: (response) => showSeason(response),
      dom_obj: dom_obj,
      createSectionTitles: (title, container) =>
        createSectionTitles(title, container)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("Menu started");
        setupEventListeners();
        // hide progress bar
        setShowProgessBar(false);

        page_view.createSectionTitles(
          "Tabla general",
          "js__seccion_title_general"
        );
        page_view.createSectionTitles(
          "Tabla ofensiva",
          "js__seccion_title_ofensive"
        );
        page_view.createSectionTitles(
          "Tabla defensiva",
          "js__seccion_title_defensive"
        );
        page_view.createSectionTitles("Tabla local", "js__seccion_title_local");
        page_view.createSectionTitles(
          "Tabla visitante",
          "js__seccion_title_visitor"
        );

        //get seasons
        page_controller.getSeasons(page_view.showSeason);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div id='js__filters'>
          <IonList className='scores-list'>
            <IonItem className='scores-select'>
              <IonSelect
                style={{ width: "100%" }}
                placeholder='Temporada'
                onIonChange={(e) => {
                  if (e.target.value != "" && e.target.value != undefined) {
                    document.getElementById(
                      "js__scores_table_container"
                    ).style.display = "";
                    document.getElementById("js__notice").style.display =
                      "none";
                    //load table points
                    controller
                      .getTable(e.target.value, "/sports/standings/season")
                      .then((response) => {
                        console.log("table", response);
                        setGeneral(response.items_standing);
                      });

                    //load table ofensive
                    controller
                      .getTable(
                        e.target.value,
                        "/sports/offensive_standings/season"
                      )
                      .then((response) => {
                        console.log("ofensive", response);
                        setOfensive(response.items_standing);
                      });

                    //load table defensive
                    controller
                      .getTable(
                        e.target.value,
                        "/sports/defensive_standings/season"
                      )
                      .then((response) => {
                        console.log("defensive", response);
                        setDefensive(response.items_standing);
                      });

                    //load table position local
                    controller
                      .getTable(
                        e.target.value,
                        "/sports/local_standings/season"
                      )
                      .then((response) => {
                        console.log("local", response);
                        setLocal(response.items_standing);
                      });

                    //load table position visitor
                    controller
                      .getTable(
                        e.target.value,
                        "/sports/visitor_standings/season"
                      )
                      .then((response) => {
                        console.log("visitor", response);
                        setVisitor(response.items_standing);
                      });
                  }
                }}
              >
                {filterSeason.map((item) => {
                  return item;
                })}
              </IonSelect>
            </IonItem>
          </IonList>

          <div
            id='js__notice'
            style={{ textAlign: "center", padding: "1rem" }}
          >
            Seleccionar una Temporada
          </div>
          <div
            id='js__scores_table_container'
            className='ion-text-center'
            style={{ padding: "1rem", display: "none" }}
          >
            {/* general */}
            <span id='js__seccion_title_general'></span>
            <header style={{ display: "flex", padding: "1rem 0" }}>
              <div style={{ flex: 1 }}>Equipo</div>
              <div style={{ flex: 1 }}>JJ</div>
              <div style={{ flex: 1 }}>JG</div>
              <div style={{ flex: 1 }}>JP</div>
              <div style={{ flex: 1 }}>PF</div>
              <div style={{ flex: 1 }}>PC</div>
              <div style={{ flex: 1 }}>Dif</div>
              <div style={{ flex: 1 }}>P</div>
            </header>

            {general.map((item) => (
              <ScoreTable
                key={item.id}
                scores={{
                  team_logo: item.team.full_url_logo,
                  team_color: item.team.team_color,
                  team_name: item.team.name,
                  jj: item.games,
                  jg: item.games_won,
                  jp: item.games_lost,
                  pf: item.points_in_favor,
                  pc: item.points_against,
                  dif: item.points_in_favor - item.points_against,
                  p: item.points
                }}
              ></ScoreTable>
            ))}

            {/* ofensive */}
            <span id='js__seccion_title_ofensive'></span>
            <header style={{ display: "flex", padding: "1rem 0" }}>
              <div style={{ flex: 1, maxWidth: "4.2rem" }}>Equipo</div>
              <div style={{ flex: 1 }}>Puntos</div>
              <div style={{ flex: 1 }}>Prom.</div>
            </header>

            {ofensive.map((item) => (
              <ScoreTable2
                key={item.id}
                scores={{
                  team_logo: item.team.full_url_logo,
                  team_color: item.team.team_color,
                  team_name: item.team.name,
                  points: item.points,
                  average: item.average
                }}
              ></ScoreTable2>
            ))}

            {/* defensive */}
            <span id='js__seccion_title_defensive'></span>
            <header style={{ display: "flex", padding: "1rem 0" }}>
              <div style={{ flex: 1, maxWidth: "4.2rem" }}>Equipo</div>
              <div style={{ flex: 1 }}>Puntos</div>
              <div style={{ flex: 1 }}>Promedio</div>
            </header>

            {defensive.map((item) => (
              <ScoreTable2
                key={item.id}
                scores={{
                  team_logo: item.team.full_url_logo,
                  team_color: item.team.team_color,
                  team_name: item.team.name,
                  points: item.points,
                  average: item.average
                }}
              ></ScoreTable2>
            ))}

            {/* local */}
            <span id='js__seccion_title_local'></span>
            <header style={{ display: "flex", padding: "1rem 0" }}>
              <div style={{ flex: 1 }}>Equipo</div>
              <div style={{ flex: 1 }}>JJ</div>
              <div style={{ flex: 1 }}>JG</div>
              <div style={{ flex: 1 }}>JP</div>
              <div style={{ flex: 1 }}>PF</div>
              <div style={{ flex: 1 }}>PC</div>
              <div style={{ flex: 1 }}>Dif</div>
            </header>

            {local.map((item) => (
              <ScoreTable
                key={item.id}
                scores={{
                  team_logo: item.team.full_url_logo,
                  team_color: item.team.team_color,
                  team_name: item.team.name,
                  jj: item.games,
                  jg: item.games_won,
                  jp: item.games_lost,
                  pf: item.points_in_favor,
                  pc: item.points_against,
                  dif: item.points_in_favor - item.points_against,
                  p: null
                }}
              ></ScoreTable>
            ))}

            {/* visitor */}
            <span id='js__seccion_title_visitor'></span>
            <header style={{ display: "flex", padding: "1rem 0" }}>
              <div style={{ flex: 1 }}>Equipo</div>
              <div style={{ flex: 1 }}>JJ</div>
              <div style={{ flex: 1 }}>JG</div>
              <div style={{ flex: 1 }}>JP</div>
              <div style={{ flex: 1 }}>PF</div>
              <div style={{ flex: 1 }}>PC</div>
              <div style={{ flex: 1 }}>Dif</div>
            </header>

            {visitor.map((item) => (
              <ScoreTable
                key={item.id}
                scores={{
                  team_logo: item.team.full_url_logo,
                  team_color: item.team.team_color,
                  team_name: item.team.name,
                  jj: item.games,
                  jg: item.games_won,
                  jp: item.games_lost,
                  pf: item.points_in_favor,
                  pc: item.points_against,
                  dif: item.points_in_favor - item.points_against,
                  p: null
                }}
              ></ScoreTable>
            ))}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Scores;
